export default function authHeader() {
  return {};
}
